import { useQuery } from 'react-query';
import { authFetch } from '../../../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../../../CommonUtils/urlWithParams';
import { SocialSecurityStrategy } from './types';
import { queryKeys } from './queryKeys';

export interface ProbabilityModelDTO {
  ProbabilityOfSuccess: number;
}

const BASE_URL = '/Consumer/OptimizeSocialSecurity/GetSocialSecurityProbability';

const fetchSocialSecurityProbability = async (
  clientId: number,
  fpId: string,
  strategy: SocialSecurityStrategy,
): Promise<ProbabilityModelDTO> => {
  return authFetch(urlWithParams(BASE_URL, { clientId, fpId, strategy }));
};

export interface Params {
  clientId: number;
  fpId: string;
  strategy: SocialSecurityStrategy;
  enabled: boolean;
}

export const useSocialSecurityProbabilityQuery = ({
  clientId,
  fpId,
  strategy,
  enabled,
}: Params) => {
  return useQuery(
    queryKeys.socialSecurityProbability(clientId, fpId, strategy),
    () => fetchSocialSecurityProbability(clientId, fpId, strategy),
    { enabled },
  );
};
